import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link } from "react-router-dom";
// import LeadIcon from './lead.svg';
import "./blur.css";
import "../../Config/loading.css";
import { Footer } from "../footer/footer";

import { useNavigate } from "react-router-dom";
import { Modal, Button } from "antd";

export default function Dashboard() {
  const [userDetails, SetUserDetails] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    SetUserDetails(userDetailsSession);
  }, []);

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const [dashboardData, SetDashboardData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const userDetailsSession = JSON.parse(
          sessionStorage.getItem("userDetails"),
        );
        const response = await fetch(
          `${API_BASE_CRM_URL}dashboard/GetDashboardData?staffid=${userDetailsSession?.staffid}`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          SetDashboardData(data.ResultData);
          setLoading(false);
        } else {
          console.error("Fetched data is not an array:", data);
          SetDashboardData([]);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [visitModalOpen, setVisitModalOpen] = useState(false);

  const handleVisitType = (type) => {
    setVisitModalOpen(false);

    navigate("/VisitNotes", {
      state: {
        type: type,
      },
    });
  };
  return (
    <>
      <style>
        {`
/* Mobile & Tablet Only */
@media (max-width: 991.98px) {

  .stats-grid .col-6 {
    position: relative;
  }

  /* Vertical center line */
  .stats-grid .col-6:nth-child(odd)::after {
    content: "";
    position: absolute;
    top: 20%;
    right: 0;
    width: 1px;
    height: 60%;
    background: linear-gradient(
      to bottom,
      rgba(255,255,255,0.05),
      rgba(255,255,255,0.25),
      rgba(255,255,255,0.05)
    );
  }

  /* Horizontal center line */
  .stats-grid .col-6:nth-child(-n+2)::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 15%;
    width: 70%;
    height: 1px;
    background: linear-gradient(
      to right,
      rgba(255,255,255,0.05),
      rgba(255,255,255,0.25),
      rgba(255,255,255,0.05)
    );
  }
}

/* Laptop & Desktop */
@media (min-width: 992px) {
  .stats-grid .col-6::before,
  .stats-grid .col-6::after {
    display: none;
  }
}
`}
      </style>

      <Base>
        <div className="container py-2">
          {loading ? (
            <p className="laoding-text">
              <div className="containers">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </p>
          ) : (
            ""
          )}

          <h3 className="fw-bold mb-1">
            Hi {userDetails.firstname} {userDetails.lastname}! 👋
          </h3>

          <p className="text-muted mb-4">
            Here's what's happening with your business today.
          </p>

          <div
            className="card border-0 shadow mb-4"
            style={{
              background: "#002366",
              borderRadius: "20px",
            }}
          >
            <div className="card-body p-0">
              <div className="row g-0 text-white stats-grid">
                <div className="col-6 col-lg-3 py-2 mb-2">
                  <Link
                    to="/customers"
                    className="text-decoration-none text-white"
                  >
                    <div className="p-3 d-flex align-items-center">
                      <div
                        className="d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: "#2563eb",
                          borderRadius: "12px",
                        }}
                      >
                        <i className="fa-solid fa-users"></i>
                      </div>

                      <div>
                        <h3 className="mb-0 text-white">
                          {dashboardData?.TotalCustomers || 0}
                        </h3>
                        <small>Customers</small>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-6 col-lg-3 py-2 mb-2">
                  <Link to="/leads" className="text-decoration-none text-white">
                    <div className="p-3 d-flex align-items-center">
                      <div
                        className="d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: "#16a34a",
                          borderRadius: "12px",
                        }}
                      >
                        <i className="fa-solid fa-headset"></i>
                      </div>

                      <div>
                        <h3 className="mb-0 text-white">
                          {dashboardData?.TotalLeads || 0}
                        </h3>
                        <small>Leads</small>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-6 col-lg-3 py-2 mb-2">
                  <Link to="/todo" className="text-decoration-none text-white">
                    <div className="p-3 d-flex align-items-center">
                      <div
                        className="d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: "#8b5cf6",
                          borderRadius: "12px",
                        }}
                      >
                        <i className="fa-regular fa-square-check"></i>
                      </div>

                      <div>
                        <h3 className="mb-0 text-white">
                          {dashboardData?.TotalTodos || 0}
                        </h3>
                        <small>Todo</small>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-6 col-lg-3 py-2 mb-2">
                  <Link
                    to="/reminders"
                    className="text-decoration-none text-white"
                  >
                    <div className="p-3 d-flex align-items-center">
                      <div
                        className="d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: "#f59e0b",
                          borderRadius: "12px",
                        }}
                      >
                        <i className="fa-regular fa-bell"></i>
                      </div>

                      <div>
                        <h3 className="mb-0 text-white">
                          {dashboardData?.TotalReminders || 0}
                        </h3>
                        <small>Follow-ups</small>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold mb-0">Quick Actions</h5>
          </div>

          <div className="row g-2 mb-2">
            <div className="col-3">
              {/* <Link className="text-decoration-none" to="/VisitNotes">
                <div
                  className="card text-center shadow  "
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-location-dot fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div
                      className="text-nowrap text-center"
                      style={{ fontSize: "12px" }}
                    >
                      Visit
                    </div>
                  </div>
                </div>
              </Link> */}
              <div
                className="text-decoration-none"
                onClick={() => setVisitModalOpen(true)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card text-center shadow"
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-location-dot fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>

                    <div
                      className="text-nowrap text-center"
                      style={{ fontSize: "12px" }}
                    >
                      Visit
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-3">
              <Link to="/leads" className="text-decoration-none">
                <div
                  className="card text-center shadow"
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-headset fs-3 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div className="text-nowrap" style={{ fontSize: "12px" }}>
                      Leads
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-3">
              <Link to="/proposal" className="text-decoration-none">
                <div
                  className="card text-center shadow"
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-file-signature fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div className="text-nowrap" style={{ fontSize: "12px" }}>
                      Proposal
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-3">
              <Link to="/tasks" className="text-decoration-none">
                <div
                  className="card text-center shadow"
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-list-check fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div className="text-nowrap" style={{ fontSize: "12px" }}>
                      Tasks
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="row g-2 mb-3">
            <div className="col-3">
              <Link to="/expenses" className="text-decoration-none">
                <div
                  className="card text-center shadow border-0"
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-receipt fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div
                      className="text-nowrap"
                      style={{
                        fontSize: "12px",
                        color: "#002366",
                        fontWeight: "600",
                      }}
                    >
                      Expenses
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-3">
              <Link to="/credits" className="text-decoration-none">
                <div
                  className="card text-center shadow border-0"
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-credit-card fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div
                      className="text-nowrap"
                      style={{
                        fontSize: "12px",
                        color: "#002366",
                        fontWeight: "600",
                      }}
                    >
                      Collections
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-3">
              <Link to="/payments" className="text-decoration-none">
                <div
                  className="card text-center shadow border-0 "
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-solid fa-money-bill-1 fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div
                      className="text-nowrap"
                      style={{
                        fontSize: "12px",
                        color: "#002366",
                        fontWeight: "600",
                      }}
                    >
                      Payments
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-3">
              <Link to="/reminders" className="text-decoration-none">
                <div
                  className="card text-center shadow border-0 "
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body py-3">
                    <i
                      className="fa-regular fa-calendar-check fs-2 mb-3"
                      style={{ color: "#002366" }}
                    ></i>
                    <div
                      className="text-nowrap"
                      style={{
                        fontSize: "12px",
                        color: "#002366",
                        fontWeight: "600",
                      }}
                    >
                      Follow-ups
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-md-6 col-sm-12 col-12 d-flex">
              <div className="card flex-fill default-cover mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 " style={{ color: "#002366" }}>
                    Recent Leads
                  </h4>
                  <div className="view-all-link">
                    <Link
                      to="/leads"
                      className="view-all d-flex align-items-center"
                    >
                      View All<i className="fa-solid fa-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive dataview">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th>Organization</th>
                          <th>Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData.RecentLeads &&
                          dashboardData.RecentLeads.map((item, index) => (
                            <tr key={index}>
                              <td title={item.Company}>
                                {item.Company && item.Company.length > 15
                                  ? item.Company.substring(0, 15) + "..."
                                  : item.Company || "N/A"}
                              </td>
                              <td title={item.Name}>
                                {item.Name && item.Name.length > 11
                                  ? item.Name.substring(0, 11) + "..."
                                  : item.Name || "N/A"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-md-4 col-sm-12 col-12 d-flex">
              <div className="card flex-fill default-cover mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 " style={{ color: "#002366" }}>
                    Recent Customers
                  </h4>
                  <div className="view-all-link">
                    <Link
                      to="/customers"
                      className="view-all d-flex align-items-center"
                    >
                      View All<i className="fa-solid fa-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive dataview">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>City</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData.RecentCustomers &&
                          dashboardData.RecentCustomers.map((item, index) => (
                            <tr key={index}>
                              <td title={item.company}>
                                {item.company && item.company.length > 15
                                  ? item.company.substring(0, 15) + "..."
                                  : item.company || "N/A"}
                              </td>
                              <td>{item.city}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-xl-4 col-md-6 col-sm-12 col-12 d-flex">
              <div className="card flex-fill default-cover mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 " style={{ color: "#002366" }}>
                    Recent Followups
                  </h4>
                  <div className="view-all-link">
                    <Link
                      to="/followups"
                      className="view-all d-flex align-items-center"
                    >
                      View All<i className="fa-solid fa-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive dataview">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData.RecentFollowups &&
                          dashboardData.RecentFollowups.map((item, index) => (
                            <tr key={index}>
                              <td>{item.RelType}</td>
                              <td>{item.FollowupType}</td>
                              <td className="text-warning">
                                {item.FollowupStatus}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <Modal
          title="Select Visit Type"
          open={visitModalOpen}
          onCancel={() => setVisitModalOpen(false)}
          footer={null}
          centered
          width={300}
        >
          <div className="d-flex gap-3 justify-content-center py-4">
            <Button
              type="primary"
              size="large"
              onClick={() => handleVisitType("lead")}
            >
              Lead
            </Button>

            <Button
              type="primary"
              size="large"
              onClick={() => handleVisitType("customer")}
            >
              Customer
            </Button>
          </div>
        </Modal>

        <Footer></Footer>
      </Base>
    </>
  );
}
